import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconArrowPathUp"><Path d="M4.36309 8.94702C3.68147 9.76057 4.25989 10.9998 5.32124 10.9998H8.00002V19.2498C8.00002 20.7686 9.23124 21.9998 10.75 21.9998H13.25C14.7688 21.9998 16 20.7686 16 19.2498V10.9998H18.6788C19.7402 10.9998 20.3186 9.76057 19.637 8.94703L13.7247 1.89046C12.8254 0.817116 11.1746 0.817112 10.2754 1.89045L4.36309 8.94702Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathUp;
